import React, { useEffect, useState } from "react";

const FinishingScheduleReport: React.FC = () => {
    return (
        <React.Fragment>
        </React.Fragment>
    )
}

export default FinishingScheduleReport;